import sendToSalesFunnel from './sendToSalesFunnel';
import addBasicPlan from './addBasicPlan';
import { FibreProviderTypes, OptionServiceTypeDisplay, } from '../models/enums';
import processPlansWithUpgrades from './processPlansWithUpgrades';
import getNodePlanData from './getNodePlanData';
import { calculateBasePrice } from './helperFunctions';
import AppState from '../AppState';
/**
 * Populates available plans for the address and performs various operations
 * related to the confirmation of services with upgrades.
 *
 * @param {AvailableSelections[]} availablePlans - Array of available selections
 *                                                 for plans.
 */
const getConfirmedServiceWithUpgrades = (availablePlans) => {
    // Populate available plans for the address
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const slabFibreServiceType = AppState.get('slabFibreServiceType');
    const addressConfirmed = AppState.get('addressConfirmed');
    const sfpModel = AppState.get('serviceFunnelPackage');
    const { context } = drupalJsObjects;
    const serviceAvailable = context.querySelector('#service-available');
    const serviceSelected = context.querySelector('#service-selected');
    const messageWrapper = context.querySelector('#message-wrapper');
    const selectDifferentPlanLink = context.querySelector('#select-different');
    const confirmationBlock = context.querySelector('#address-confirmation-4');
    context.querySelector('#service-available-icon').style.display = 'block';
    serviceAvailable.classList.add('p-lg-4', 'address-tile');
    serviceAvailable.querySelector('.service-available--text').style.display = 'block';
    messageWrapper.classList.add('service-available--congratulations');
    if (selectDifferentPlanLink) {
        selectDifferentPlanLink.style.display = 'none';
    }
    confirmationBlock.appendChild(addressConfirmed);
    confirmationBlock.style.display = 'block';
    context.querySelector('#package-confirmation-message').innerText = `Great! ${OptionServiceTypeDisplay[slabFibreServiceType]} is available.`;
    context.querySelector('#plan-name-1').innerText = FibreProviderTypes[sfpModel.provider];
    const selectedPlanNext = context.querySelector('#address-check-next');
    serviceSelected.style.marginBottom = '2rem';
    messageWrapper.style.display = 'block';
    selectedPlanNext.style.display = 'block';
    context.querySelector('#plan-selection-title').style.display = 'none';
    // Assemble plans
    const selectedPlan = sfpModel.bundles.find((bundle) => bundle.PlanGroupID === 162);
    const basicPlan = addBasicPlan(selectedPlan);
    const allPlans = availablePlans.concat(basicPlan);
    processPlansWithUpgrades(selectedPlan, allPlans);
    // Send select plan data to Sales Funnel.
    selectedPlanNext.onclick = (event) => {
        event.preventDefault();
        const selectedPlanEl = context.querySelector('.service-plans--service-plan.selected');
        const selectedPlanId = selectedPlanEl.getAttribute('data-plan-identifier');
        const nonProcessedPlans = allPlans.map(plan => {
            const basePrice = calculateBasePrice(selectedPlan);
            plan.price = basePrice + plan.OptionFee;
            return plan;
        });
        const planType = AppState.get('planType');
        AppState.set('selectedPlanData', getNodePlanData(selectedPlanId, planType));
        sendToSalesFunnel(selectedPlanId, nonProcessedPlans)
            .catch(error => console.log(error));
    };
};
export default getConfirmedServiceWithUpgrades;
